package one.healthium.log_symptoms.ui

import loco.GENERAL_SYMPTOM_BLOATING
import loco.GENERAL_SYMPTOM_CONSTIPATION
import loco.GENERAL_SYMPTOM_EXCESS_GAS
import loco.GENERAL_SYMPTOM_UNKNOWN
import one.healthium.domain.user.models.SymptomKind
import one.healthium.domain.user.models.SymptomSeverity
import one.healthium.loco.LString
import one.healthium.loco.asLString
import androidx.compose.runtime.Immutable

@Immutable
data class SymptomUiModel(
    val kind: SymptomKind,
    val severities: List<SymptomSeverity>,
    val selectedSeverity: SymptomSeverity?,
) {
    val displayName: LString = when (kind) {
        SymptomKind.Bloating -> loco.Res.string.GENERAL_SYMPTOM_BLOATING
        SymptomKind.ExcessGas -> loco.Res.string.GENERAL_SYMPTOM_EXCESS_GAS
        SymptomKind.Constipation -> loco.Res.string.GENERAL_SYMPTOM_CONSTIPATION
        SymptomKind.Unknown -> loco.Res.string.GENERAL_SYMPTOM_UNKNOWN
    }.asLString()
}
